import React, { useContext, useEffect, useState } from "react";
import { parseCookies } from "nookies";
import api from "../../services/api";

import { RouterContext } from "../../contexts/routerContext";

import { FaMicrophoneAltSlash } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { MdCallEnd } from "react-icons/md";
import { RiKeyboardLine } from "react-icons/ri";
import { HiOutlinePhoneOutgoing } from "react-icons/hi";

import Header from "../../components/v2/layout/header";
import {
  Container,
  ContentContainer,
  HeaderConfiguration,
  Avatar,
  InputContainer,
  ContentBackground,
  ButtonSecondaryContainer,
  ButtonCancel,
  ButtonAction,
} from "./styles";
import { WidgetContext } from "../../contexts/widgetContext";

const CallInProgress = () => {
  const { setRouter, routerParams: paramsContact } = useContext(RouterContext);
  const { interationSIP, timer, setCallInProgress, callInProgress } =
    useContext(WidgetContext);
  const [avatarText, setAvatarText] = useState("");
  const [mute, setMute] = useState(false);
  const [contact, setContact] = useState(undefined);
  const [photo, setPhoto] = useState();

  useEffect(() => {
    if (contact) {
      const usernameText = contact.name.split(" ");
      const primaryLetter = usernameText[0]?.substr(0, 1).toLocaleUpperCase();
      const secondaryLetter = usernameText[1]?.substr(0, 1).toLocaleUpperCase();
      setAvatarText(
        `${primaryLetter ? primaryLetter : ""}${
          secondaryLetter ? secondaryLetter : ""
        }`
      );

      const userPhoto = contact?.photo ? contact?.photo : undefined;
      if (userPhoto) {
        setPhoto(require(`../../assets/images/avatares/user_${userPhoto}.png`));
      }
    }
  }, [contact]);

  useEffect(() => {
    setCallInProgress({
      type: callInProgress.type,
      number: callInProgress.number,
      time: callInProgress.time,
      status: callInProgress.status,
      answered_call: callInProgress.answered_call,
    });
    localStorage.setItem(
      "@WEBPHONE.CALLINPROGRESS",
      JSON.stringify({
        type: callInProgress.type,
        number: callInProgress.number,
        time: callInProgress.time,
        status: callInProgress.status,
        answered_call: callInProgress.answered_call,
      })
    );

    const { "bcattendant.token": token } = parseCookies();
    if (token) {
      api.get("attendant").then((response) => {
        api
          .post(`/contacts/${response.data.id}/contact`, {
            phone_number: callInProgress.number,
          })
          .then((res) => {
            setContact(res.data);
          });
      });
    }
  }, []);

  // Mutar ou Desmutar chamada
  const handleMuteCall = () => {
    interationSIP.toggleMute().then((isMuted) => {
      if (isMuted) {
        setMute(true);
      } else {
        setMute(false);
      }
    });
  };

  // Finalizar chamada
  const handleEndCall = () => {
    interationSIP.hangup().then(() => {});
  };

  return (
    <Container>
      <Header buttonBack={false}>
        <HeaderConfiguration>
          <Avatar>
            {paramsContact?.caminho_imagem ? (
              <img
                src={`https://api-agente.tallk.me/${paramsContact.caminho_imagem}`}
                alt="Foto do contato"
              />
            ) : (
              `${avatarText}`
            )}
          </Avatar>
          <span>
            {paramsContact?.name
              ? paramsContact.name
              : contact?.name
              ? contact?.name
              : callInProgress.number}
          </span>
        </HeaderConfiguration>
      </Header>
      <InputContainer>
        <span>
          {callInProgress.type === "Saida" ? "Ligando...:" : "Recebendo...:"}
        </span>
        <span>{timer}</span>
      </InputContainer>

      <ContentContainer>
        <ContentBackground>
          <FiPhoneCall size={72} color="#C4C4C4" />
        </ContentBackground>
      </ContentContainer>
      <ButtonCancel onClick={handleEndCall}>
        <MdCallEnd size={24} color="#FFF" />
      </ButtonCancel>
      <ButtonSecondaryContainer>
        {/*<ButtonAction onClick={() => setRouter("schedule")}>*/}
        {/*  <HiOutlinePhoneOutgoing size={24} color="#FFF" />*/}
        {/*</ButtonAction>*/}
        <ButtonAction check={mute} onClick={handleMuteCall}>
          <FaMicrophoneAltSlash size={24} color="#FFF" />
        </ButtonAction>
        {/*<ButtonAction onClick={() => setRouter("make-a-call")}>*/}
        {/*  <RiKeyboardLine size={24} color="#FFF" />*/}
        {/*</ButtonAction>*/}
      </ButtonSecondaryContainer>
    </Container>
  );
};

export default CallInProgress;
